import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

const styles = {
  list: {
    display: 'flex',
    listStyleType: 'none',
  },
};

export const ThumbnailImageField = ({ elStyle = {}, record, source, src, title, sizeX = 200, sizeY = 160, serverBaseUrl = 'http://images.pinchos.se' }) => {
  const sourceValue = get(record, source);
  if (!sourceValue) {
    return <div />;
  }
  styles.image = {
    margin: '0.5rem',
    height: `${sizeY}px`,
  };

  if (Array.isArray(sourceValue)) {
    const style = {
      ...styles.list,
      ...elStyle,
    };
    return (
      <ul style={style}>
        {sourceValue.map((file, index) => {
          const titleValue = get(file, title) || title;
          const srcValue = get(file, src) || title;
          return (
            // eslint-disable-next-line react/no-array-index-key
            <li key={index}>
              <img
                alt={titleValue}
                title={titleValue}
                src={srcValue.indexOf('blob') === 0 || srcValue.indexOf('gif') !== 0 ? srcValue : `${serverBaseUrl}/unsafe/${sizeX}x${sizeY}/smart/${srcValue}`}
                style={styles.image}
              />
            </li>
          );
        })}
      </ul>
    );
  }

  const titleValue = get(record, title) || title;

  return (
    <div style={elStyle}>
      <img
        title={titleValue}
        alt={titleValue}
        src={sourceValue.indexOf('blob') === 0 || sourceValue.indexOf('gif') !== 0 ? sourceValue : `${serverBaseUrl}/unsafe/${sizeX}x${sizeY}/smart/${sourceValue}`}
        style={styles.image}
      />
    </div>
  );
};

ThumbnailImageField.propTypes = {
  elStyle: PropTypes.object,
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default ThumbnailImageField;
